import { gridStoreResults } from 'fox-react/dist/components/FoxGrid/actions';
import gridNames from 'common/gridNames';
import TransportOrdersSrv from './TransportOrdersSrv';

export function storeResults(results) {
  return gridStoreResults(gridNames.transportOrders)(results);
}

export function getForGrid(dataState) {
  return function(dispatch) {
    return TransportOrdersSrv.getForGrid(dataState).then(results => {
      dispatch(storeResults(results));
    });
  };
}
